import React from "react";
import clsx from "clsx";

const SectionHeader = ({
  eyebrow,
  title,
  subtitle,
  align = "center",
  className,
}) => {
  const alignment = {
    left: "text-left items-start",
    center: "text-center items-center",
    right: "text-right items-end",
  };

  return (
    <div
      className={clsx(
        "flex flex-col gap-3 max-w-3xl",
        alignment[align],
        className
      )}
    >
      {eyebrow && (
        <span className="text-sm font-semibold tracking-widest uppercase text-blue-600">
          {eyebrow}
        </span>
      )}

      {title && (
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
          {title}
        </h2>
      )}

      {subtitle && (
        <p className="text-base sm:text-lg text-slate-600 leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
